// extracted by mini-css-extract-plugin
module.exports = {"item":"gallery-item-module--item--3rzRl","content":"gallery-item-module--content--2LIi7"};